<template>
    <div class="main-content">
        <div class="top">
            <div class="top-header">
                <!-- <img src="@/assets/images/doctor-discuss.jpg" style="width:100%;border-radius:8px;" /> -->
            </div>
        </div>
        <div class="team-form">
            <h3 class="team-form-title">填写团队体检申请</h3>
            <h3 class="team-form-desc">完善以下内容,我们将尽快与您联系</h3>
            <h3 class="team-form-remark">仅限单位健康体检预约 仅限团队负责人填写</h3>
            <van-form @submit="onSubmit()">
                <van-field v-model="formData.company_name" name="" label="单位" placeholder="填写单位名称"
                    :rules="[{ required: true, message: '请填写您的单位名称' }]" maxlength="20" />
                <van-field v-model="formData.contact" name="" label="联系人" placeholder="单位联系人的姓名"
                    :rules="[{ required: true, message: '请填写联系人的姓名' }]" maxlength="20" />
                <van-field v-model="formData.phone_num" name="" label="联系电话" placeholder="单位联系电话"
                    :rules="[{ required: true, message: '请填写联系电话' }]" maxlength="20" />
                <van-field v-model="formData.estimate_num" name="" label="预计参检人数" placeholder="填写预计的体检人数"
                    maxlength="20" />
                <van-field v-model="formData.budget" name="" label="人均预算" placeholder="单位人均预算" maxlength="20" />
                <van-field v-model="formData.expected_date" name="" label="期望体检日期" placeholder="您希望何时体检"
                    maxlength="20" />
                <van-field v-model="formData.remark" name="" label="留言备注" placeholder="填写您的其它需求信息" rows="3" autosize
                    type="textarea" maxlength="60" />
                <div class="team-form-btn">
                    <van-button size="large" type="info" native-type="submit">提交申请</van-button>
                    <div class="record-btn" v-if="requirement != null">
                        <a @click="showRequirement()">查看提交的申请记录</a>
                    </div>
                </div>
            </van-form>
        </div>

        <!-- 显示已提交的申请信息 -->
        <van-popup position="bottom" v-model="modalVisible" round :style="{ height: '70%' }" class="req-wrapper">
            <div v-if="requirement">
                <h3 class="req-title">查看申请信息</h3>
                <p class="req-status">{{requirement.status|reqStatus}}</p>
                <van-form readonly>
                    <van-field v-model="requirement.company_name" label="单位" />
                    <van-field v-model="requirement.contact" label="联系人" />
                    <van-field v-model="requirement.phone_num" label="联系电话" />
                    <van-field v-model="requirement.estimate_num" label="预计参检人数" />
                    <van-field v-model="requirement.budget" label="人均预算" />
                    <van-field v-model="requirement.expected_date" name="" label="期望体检日期" />
                    <van-field v-model="requirement.remark" name="" label="留言备注" autosize type="textarea" />
                    <div style="padding:24px;">
                        <van-button plain hairline size="large" type="danger" @click="cancelRequirement()">撤消申请
                        </van-button>
                    </div>
                </van-form>
            </div>
        </van-popup>
    </div>
</template>

<style lang="less" scoped>
    .main-content {
        height: 100vh;
        background-color: #ffffff;
    }

    .top {
        width: 100%;
        position: relative;
        z-index: 0;
        overflow: hidden;
        color: #ffffff;
        height: 160px;
        background-image: url("../../assets/images/doctor-discuss.jpg");
        background-size: 100%;
    }

    .team-form {
        background-color: #ffffff;
        border-radius: 8px;

        .team-form-title {
            font-size: 20px;
            text-align: center;
            padding: 12px 0;
            margin-top: 12px;
        }

        .team-form-remark {
            color: #fc5531;
            text-align: center;
            font-size: 14px;
            margin-bottom: 12px;
        }

        .team-form-desc {
            text-align: center;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.6);
            
        }

        .team-form-btn {
            padding: 20px;

            .record-btn {
                padding: 20px;
                text-align: center;
                font-size: 14px;
                color: rgba(0, 0, 0, 0.6);
            }
        }
    }

    .req-wrapper {
        .req-title {
            margin-top: 12px;
            text-align: center;
        }

        .req-status {
            padding: 12px;
            text-align: center;
            font-size: 14px;
        }
    }

    .container {
        width: calc(100% - 20px);
        min-height: 100vh;
        top: 0;
        left: 0;
        padding: 10px;
        padding-bottom: 60px;

        .header {
            color: #ffffff;

            h3 {
                line-height: 36px;
                font-size: 20px;
                font-weight: 600;
            }

            p {
                font-size: 14px;
            }
        }
    }
</style>

<script>
    import {
        getRequirement,
        saveRequirement,
    } from '@/api/company';
    import * as user_api from '@/api/user'

    import moment from 'moment';
    export default {
        data() {
            return {
                requirement: null,
                formData: {
                    hosp_id: "",
                    user_account_id: 0,
                    company_name: "",
                    contact: "",
                    phone_num: "",
                    expected_date: "",
                    estimate_num: "",
                    remark: ""
                },
                modalVisible: false
            }
        },
        computed: {
            hospId: function () {
                return this.$route.query.hospid;
            },
            userId: function () {
                let userInfo = user_api.getLoginedUser();
                return userInfo.id;
            }
        },
        filters: {
            reqStatus: function (value) {
                switch (value) {
                    case 0:
                        return "申请已提交"
                        break;
                    case 1:
                        return "已受理"
                        break;
                    case 9:
                        return "已取消"
                        break;
                    default:
                        return ""
                        break;
                }
            }
        },
        mounted() {
            let userInfo = user_api.getLoginedUser();
            this.formData.user_account_id = userInfo.id;
            this.formData.hosp_id = this.hospId;
            getRequirement(this.hospId).then(res => {
                this.requirement = res.data;
            })
        },
        methods: {
            onSubmit() {
                this.formData.create_time = new Date();
                this.formData.update_time = new Date();
                console.log('submit', this.formData);

                saveRequirement(this.formData).then(res => {
                    if (res.code == 200) {
                        this.$toast.success("提交申请成功!")
                        setTimeout(() => {
                            this.$router.replace('/');
                        }, 1500);
                    } else {
                        this.$toast.fail(res.msg)
                    }
                })
            },
            showRequirement() {
                this.modalVisible = true;
            },
            cancelRequirement() {
                if (this.requirement == null)
                    return;
                this.requirement.status = 9;
                saveRequirement(this.requirement).then(res => {
                    if (res.code == 200) {
                        this.$toast("团检申请已撤消");
                        this.requirement = null;
                        this.modalVisible = false;
                    } else {
                        this.$toast.fail("团检申请撤消失败!")
                    }
                })
            }
        },
        created() {
            let hospid = this.$route.query.hospid;
        }
    }
</script>